export default {
    getModalConnectWithData: function(state) {
        return state.modalConnectWithData;
    },
    getModalConnectWithOptions: function(state) {
        return state.modalConnectWithOptions;
    },
    allNotAllocatedDocuments: function(state) {
        return state.modalConnectWithData.documents.concat(
            state.modalConnectWithData.unallocated_documents
        );
    },
    getConnectedItem: function(state) {
        return function(type, index) {
            let item = null;
            switch (type) {
                case 'operation':
                    item = state.modalConnectWithData.unallocated_payments[index];
                    break;
                case 'document':
                    item = state.modalConnectWithData.documents[index];
                    break;
                case 'unallocated_document':
                    item = state.modalConnectWithData.unallocated_documents[index];
                    break;
            }
            return item;
        };
    },
}